<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" style="background: #f9f9f9;">
                    <div class="vx-row no-gutter justify-center items-center">
                        <div class="vx-col hidden lg:block lg:w-1/2">
                            <img src="@/assets/images/team/default_team.png" alt="login" style="width:100%">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                            <div class="p-8">
                                
                                <div class="vx-card__title mb-8">
                                    <h3 class="mb-4 flex justify-between">
                                        <span style="padding: 7px">登录</span>
                                        <vs-button size="small" icon="icon icon-arrow-left" icon-pack="feather" type="flat" href="/match/list.html">返回赛事主页</vs-button>
                                    </h3>
                                    <p>欢迎使用Match赛事平台 - 个人中心，请登录您的账号</p>
                                </div>
                                <vs-input
                                    v-validate="'required|min:3'"
                                    data-vv-validate-on="blur"
                                    name="username"
                                    icon="icon icon-user"
                                    icon-pack="feather"
                                    label-placeholder="账号"
                                    v-model="username"
                                    class="w-full no-icon-border"/>
                                <span class="text-danger text-sm">{{ errors.first('username') }}</span>

                                <vs-input
                                    data-vv-validate-on="blur"
                                    v-validate="'required|min:6|max:18'"
                                    type="password"
                                    name="password"
                                    icon="icon icon-lock"
                                    icon-pack="feather"
                                    label-placeholder="密码"
                                    v-model="password"
                                    @keyup.enter.native="login"
                                    class="w-full mt-6 no-icon-border" />
                                <span class="text-danger text-sm">{{ errors.first('password') }}</span>

                                <div class="flex flex-wrap justify-between my-5">
                                    <vs-checkbox v-model="checkbox_remember_me" class="mb-3">记住我</vs-checkbox>
                                    <router-link to="/pages/forgot-password">忘记密码？</router-link>
                                </div>
                                <vs-button  type="border" @click="registerUser">注册</vs-button>
                                <vs-button class="float-right" :disabled="!validateForm" @click="login">登录</vs-button>

                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>

import { Validator } from 'vee-validate'

const dict = {
    custom: {
        username: {
            required: '请输入你的用户名',
            alpha_dash: '你的用户名不能包含特殊字符，允许的字符字母及数字',
            min: '用户名不能小于三个字符'
        },
        password: {
            required: '请输入你的密码',
            min: '密码的长度不能小于6',
            max: '密码的长度不能大于18'
        },
    }
}

Validator.localize('zh', dict)

export default {
    data() {
        return {
            username: '',
            password: '',
            checkbox_remember_me: false
        }
    },
    components: {
    },
    computed: {
        validateForm() {
            return !this.errors.any() && this.username != '' && this.password != '';
        },
    },
    methods: {
        login() {
            const payload = {
                checkbox_remember_me: this.checkbox_remember_me,
                userDetails: {
                    username: this.username,
                    password: this.password
                },
                notify: this.$vs.notify,
            }
            this.$store.dispatch('auth/loginAttempt', payload);
        },

        loginAuth0() {
            if (this.$store.state.auth.isUserLoggedIn()) {
                this.notifyAlreadyLogedIn();
                return false
            }
            this.$auth.login({ target: this.$route.query.to });
        },

        // Google login
        loginWithGoogle() {
            this.$store.dispatch('auth/loginWithGoogle', {notify: this.$vs.notify})
        },

        // Facebook login
        loginWithFacebook() {
            this.$store.dispatch('auth/loginWithFacebook', {notify: this.$vs.notify})
        },

        // Twitter login
        loginWithTwitter() {
            this.$store.dispatch('auth/loginWithTwitter', {notify: this.$vs.notify})
        },

        // Github login
        loginWithGithub() {
            this.$store.dispatch('auth/loginWithGithub', {notify: this.$vs.notify})
        },

        notifyAlreadyLogedIn() {
            this.$vs.notify({
                title: 'Login Attempt',
                text: 'You are already logged in!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            });
        },
        registerUser() {
            if(this.$store.state.auth.isUserLoggedIn()) {
                this.notifyAlreadyLogedIn();
                return false;
            }
            this.$router.push('/pages/register');
        }
    }
}
</script>

<style lang="scss">
#page-login {
    .social-login {
        .bg-facebook {
          background-color: #1551b1;
        }
        .bg-twitter {
          background-color: #00aaff;
        }
        .bg-google {
          background-color: #4285F4;
        }
        .bg-github {
          background-color: #333;
        }
    }
}
</style>
